export const getSlaughtersList = ({ accountings }) => accountings.slaughtersList;

export const getAccountings = ({ accountings }) => accountings.accountings;

export const getDocuments = ({ accountings }) => accountings.documents;

export const getFarmerStatistics = ({ accountings }) => accountings.farmerStatistics;
export const getIsFetchingForFilter = ({ accountings }) => accountings.farmerStatistics;
export const getSlaughterhouseStatistics = ({ accountings }) => accountings.slaughterhouseStatistics;
export const getDashboardStatistics = ({ accountings }) => accountings.dashboardStatistics;
export const getAnimalKindsWithStats = ({ accountings }) => accountings.animalKindsWithStats;
